import { useCallback, useState } from "react";
import { Group, Text } from "@mantine/core";
import { IconUpload, IconX, IconPlugConnected } from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import { uploadPlugin } from "../api";
import { rem } from "@mantine/core";
import { useStore } from "../store";
import { notifications } from "@mantine/notifications";
import mixpanel from "../tracking";

function PluginUploader() {
  const [isUploading, setIsUploading] = useState(false);
  const pluginData = useStore((state) => state.pluginData);
  const setPluginData = useStore((state) => state.setPluginData);

  const onDrop = useCallback(
    (acceptedFiles) => {
      setIsUploading(true);
      const file = acceptedFiles[0];
      uploadPlugin(file)
        .then((data) => {
          setIsUploading(false);
          setPluginData([...(pluginData ?? []), data]);
          mixpanel.track("Plugin upload finished");
        })
        .catch((err) => {
          setIsUploading(false);
          const message =
            err?.message ??
            "Upload failed. Make sure the file is a valid .pvx plugin packaged for this server.";
          notifications.show({
            color: "red",
            autoClose: 6000,
            title: "Plugin upload failed",
            message,
          });
          console.error(err);
          mixpanel.track("Plugin upload failed!");
        });
    },
    [pluginData, setPluginData]
  );

  return (
    <div style={{ position: "relative" }}>
      <Dropzone
        onDrop={onDrop}
        onReject={(files) => console.log("rejected files", files)}
        maxSize={4 * 1024 ** 2}
        loading={isUploading}
      >
        <Group
          justify="center"
          gap="xl"
          mih={{ base: 160, sm: 220 }}
          style={{ pointerEvents: "none" }}
        >
          <Dropzone.Accept>
            <IconUpload
              style={{
                width: rem(52),
                height: rem(52),
                color: "var(--mantine-color-blue-6)",
              }}
              stroke={1.5}
            />
          </Dropzone.Accept>
          <Dropzone.Reject>
            <IconX
              style={{
                width: rem(52),
                height: rem(52),
                color: "var(--mantine-color-red-6)",
              }}
              stroke={1.5}
            />
          </Dropzone.Reject>
          <Dropzone.Idle>
            <IconPlugConnected
              style={{
                width: rem(52),
                minHeight: rem(52),
                color: "var(--mantine-color-dimmed)",
              }}
              stroke={1.5}
            />
          </Dropzone.Idle>
          <div>
            <Text size="xl" inline>
              Tap or click to select a PhotoVortex Plugin (.pvx),
              or drag them here
            </Text>
            <Text size="sm" c="dimmed" inline mt={7}>
              Must not exceed 4mb
            </Text>
          </div>
        </Group>
      </Dropzone>
    </div>
  );
}

export default PluginUploader;
